import { Component, OnInit, Input } from '@angular/core';
import { CriticaService } from 'src/app/service/critica/critica.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'app-natureza-administrativa-critica',
  templateUrl: './natureza-administrativa-critica.component.html',
  styleUrls: ['./natureza-administrativa-critica.component.css']
})
export class NaturezaAdministrativaCriticaComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  listaClassificacaoComponente = [];

  constructor(
    public service: CriticaService,
    private desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) {
  }

  ngOnInit() {

    this.preencherListaClassificacao();

    if (!this.visualizacao && !this.edicao) {

      this.service.critica.controls.descricaoCritica.setValue('');

    }

  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.critica.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.critica.value.assunto.id);
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.critica.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.critica.controls[str].touched &&
      this.service.critica.controls[str].errors != null;
  }
}
